import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

// The feedback address is drawn into an image on demand instead of being
// written as text or a mailto: link, which keeps it away from address scrapers.
export function ContactEmail() {
    const { t } = useTranslation();
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const [imageUrl, setImageUrl] = useState<string>();

    const toggle = () => {
        if (imageUrl !== undefined) {
            setImageUrl(undefined);
            return;
        }
        const canvas = canvasRef.current;
        const context = canvas?.getContext('2d');
        if (!canvas || !context) {
            return;
        }
        canvas.width = 170;
        canvas.height = 24;
        context.fillStyle = getComputedStyle(document.documentElement).getPropertyValue('--fg').trim() || '#000';
        context.font = '13px "IBM Plex Mono", monospace';
        context.textBaseline = 'middle';
        context.fillText(['info', 'nhlcountries.com'].join('@'), 2, 12);
        setImageUrl(canvas.toDataURL());
    };

    return (
        <>
            <canvas ref={canvasRef} hidden />
            <button type="button" className="menu-link" onClick={toggle} aria-expanded={imageUrl !== undefined}>
                {imageUrl !== undefined ? t('menu_hideAddress') : t('menu_showAddress')} ›
            </button>
            {imageUrl !== undefined && <img className="menu-email" src={imageUrl} alt={t('menu_feedback')} />}
        </>
    );
}
